<template>
    <div>
        <supa-base-header-sec class="mb-0"></supa-base-header-sec>
        <supa-advanced-search-base-header-sec></supa-advanced-search-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <b-form @submit.stop.prevent="onSubmit" @reset="onReset" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input id="titleQuery" v-model="form.titleQuery" type="text"
                                    class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input id="bodyQuery" v-model="form.bodyQuery" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label"> Суд </label>
                                <select v-model="courtType" class="form-control full-width">
                                    <option value="-1">Сви Уставни судови</option>
                                    <option v-for="option in courtTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group v-if="courts.length > 0" class="form-group-sm">
                                <label class="form-label">Судско одељење</label>
                                <select v-model="form.court" class="form-control full-width">
                                    <option value="-1">Сва одељења</option>
                                    <option v-for="item in courts" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Уписник</label>
                                <select v-model="form.upisnik" class="form-control full-width">
                                    <option value="-1">Сви уписници</option>
                                    <option v-for="option in upisnikList" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Ознака и број акта </label>
                                <input id="upisnik" v-model="form.actId" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Садржи</label>
                                <select v-model="contentType" class="form-control full-width">
                                    <option v-for="option in itemSelectionsList" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group v-if="subItemSelectionsList.length > 0" class="form-group-sm">
                                <label class="form-label">Подврста садржаја</label>
                                <select v-model="form.subItemSelection" class="form-control full-width">
                                    <option v-for="option in subItemSelectionsList" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                        </div>
                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Оспорен акт</label>
                                <input id="chalActId" v-model="form.chalActId" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Пропис битан за пресуђење</label>
                                <input id="essRule" v-model="form.essRule" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input id="articles" v-model="form.articles" type="text" class="form-control full-width">
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Релевантно право</label>
                                <input id="relLaw" v-model="form.relLaw" type="text" class="form-control full-width">
                            </b-form-group>

                            <b-form-group class="form-group-sm">
                                <label class="form-label">Врста поступка</label>
                                <select v-model="procedureTypeFilterId" class="form-control full-width">
                                    <option v-for="option in procedureTypeFilter" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <b-form-group v-if="procedureTypes" class="form-group-sm">
                                <label class="form-label">Подврста поступка</label>
                                <select v-model="form.procedureTypeId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све врсте поступака</option>
                                    <option v-for="option in procedureTypes" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                        </div>

                        <div class="col-md-4">
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна област</label>
                                <select v-model="form.legalAreaId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне области</option>
                                    <option v-for="option in legalAreas" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Правна материја</label>
                                <select v-model="legalSubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне материје</option>
                                    <option v-for="option in legalSubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm" v-if="legalSubSubjects.length > 0">
                                <label class="form-label">Правна подматерија</label>
                                <select v-model="legalSubSubjectId" class="form-control full-width">
                                    <option value="-1" selected="selected">Све правне подматерије</option>
                                    <option v-for="option in legalSubSubjects" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>
                            <b-form-group class="form-group-sm">
                                <label class="form-label">Начин објављивања</label>
                                <select v-model="publishingMethod" class="form-control full-width">
                                    <option value="-1" selected="selected">Све врсте објава</option>
                                    <option v-for="option in filterData.publishingMethods" v-bind:key="option.k"
                                        :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Books -->
                            <b-form-group class="form-group-sm" v-if="books.length > 0">
                                <label class="form-label">Производи/књига</label>
                                <select v-model="book" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in books" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Biltens -->
                            <b-form-group class="form-group-sm" v-if="biltens.length > 0">
                                <label class="form-label">Назив билтена</label>
                                <select v-model="bilten" class="form-control full-width">
                                    <option value="-1" selected="selected">Све</option>
                                    <option v-for="option in biltens" v-bind:key="option.k" :value="option.k">
                                        {{ option.l }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Sites -->
                            <b-form-group class="form-group-sm" v-if="sites.length > 0">
                                <label class="form-label">Адреса сајта</label>
                                <select v-model="site" class="form-control full-width">
                                    <option value="*" selected="selected">Све</option>
                                    <option v-for="option in sites" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                            </b-form-group>

                            <!-- Issues -->
                            <div class="row" v-if="years.length > 0">
                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Година</label>
                                    <select v-model="year" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in years" v-bind:key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>

                                <b-form-group class="form-group-sm col-md-6">
                                    <label class="form-label">Број</label>
                                    <select v-model="issue" class="form-control full-width">
                                        <option value="*" selected="selected">Све</option>
                                        <option v-for="option in issues" v-bind:key="option" :value="option">
                                            {{ option }}
                                        </option>
                                    </select>
                                </b-form-group>
                            </div>

                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум од</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateFrom"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesFrom"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум до</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateTo"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesTo"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>
                            <!--                            <p>emitedDateFromVal: {{emitedDateFromVal}}</p>-->
                            <!--                            <p>emitedDateToVal: {{emitedDateToVal}}</p>-->

                        </div>
                    </div>

                    <div class="spacer20"></div>

                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="resultLimit" class="form-label mr-2">Величина резултата</label>
                                <select id="resultLimit" v-model="form.resultLimit" class="form-control">
                                    <option v-for="option in resultLimitOptions" v-bind:key="option" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3" v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="submit" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </b-button>
                            <b-button type="reset" class="btn btn-base-reset text-uppercase mr-3">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </b-button>
                            <b-button type="button" class="btn btn-base-reset text-uppercase" @click="copyQuery"
                                v-if="canCopyQuery" style="margin: 5px 0 0 0;">
                                <span class="icon-copy mr-2"></span>
                                Kopiraj upit
                            </b-button>
                        </div>
                    </div>
                </b-form>
            </div>

            <result-counter :count="resultSize" :limit="limit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="timestamp"-->
                <!--                              dir="desc"-->
                <!--                              class="table table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="courtName">Назив суда</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="subjectId">Ознака и број предмета</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="timestamp">Датум доношења</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="name">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuer">Начин објављивања</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="issuePage">Број и страна</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.courtName}}</td>-->
                <!--                            <td>{{item.subjectId}}</td>-->
                <!--                            <td>{{item.date}}</td>-->
                <!--                            <td><a :href="baseApiUrl + 'supa/viewAct/naziv-akta/' + item.htmlUuid" target="_blank">{{item.name}}</a>-->
                <!--                            </td>-->
                <!--                            <td>{{item.issuer}}</td>-->
                <!--                            <td>{{item.issuePage}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->



                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields"
                    :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive="sm">

                    <template v-slot:cell(subjectId)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.subjectId
                        }}</router-link>
                    </template>

                    <template v-slot:cell(name)="data">
                        <router-link target="_blank" :to="{ path: '/supa/viewAct/' + data.item.id }">{{
                            data.item.name
                        }}</router-link>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                        {{ data.item.date }}
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import SupaBaseHeaderSec from '@/base_pages/supa/SupaBaseHeaderSec.vue';
import SupaAdvancedSearchBaseHeaderSec from '@/base_pages/supa/SupaAdvancedSearchBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
// import {SortedTable, SortLink} from "vue-sorted-table";
import { srCYRL } from 'vuejs-datepicker/dist/locale'
import ResultCounter from '@/partials/ResultCounter.vue';

import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
import { mapState } from 'vuex';


export default {
    name: "SupaAdvancedSearchCcSearchPage",
    data() {
        return {
            limit: 50,
            sortBy: 'timestamp',
            sortDesc: true,
            fields: [
                { label: 'Назив суда', key: 'courtName', sortable: true },
                { label: 'Ознака и број предмета', key: 'subjectId', sortable: true },
                { label: 'Датум доношења', key: 'timestamp', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'name', sortable: true },
                { label: 'Начин објављивања', key: 'issuer', sortable: true },
                { label: 'Број и страна', key: 'issuePage', sortable: true },

            ],


            emitedDateFromVal: null,
            emitedDateToVal: null,
            srCYRL: srCYRL,

            courtType: -1,
            contentType: -1,
            contentSubtype: -1,
            procedureTypeFilterId: -1,
            legalSubjectId: -1,
            legalSubSubjectId: -1,
            publishingMethod: -1,

            dateFrom: null,
            dateTo: null,

            courts: [],
            legalSubSubjects: [],


            // publishing types
            years: [],
            issues: [],
            sites: [],
            biltens: [],
            books: [],

            year: '*',
            issue: '*',
            bilten: -1,
            book: -1,
            site: '*',


            form: {

                legalAreaId: -1,
                procedureTypeId: -1,
                chalActId: null,
                essRule: null,
                articles: null,
                itemSelection: -1,
                subItemSelection: -1,
                upisnik: -1,
                actId: null,
                relLaw: null,
                court: -1,
                regulation: null,
                titleQuery: null,
                bodyQuery: null,
                resultLimit: 50,
            },

            resultLimitOptions: [50, 100, 200, 300, 400, 500],
            procedureTypeFilter: [{ k: -1, l: 'Све врсте поступака' }, { k: 0, l: 'Архивски' }, { k: 1, l: 'Актуелни' }],
            procedureTypes: null,
            legalAreas: null,
            legalSubjects: null,

            resultLimit: 50,
            resultSize: null,
            result: [],

            filterData: {
                publishingMethods: [],
            },

            // Form option lists
            courtTypes: null,
            courtsList: null,
            itemSelectionsList: null,
            subItemSelectionsList: [],
            upisnikList: null,

            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,
            baseSPApiUrl: window.env.VUE_APP_API_SP_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SupaBaseHeaderSec,
        SupaAdvancedSearchBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
        canCopyQuery() {
            if (this.userInfoState && this.searchResult !== null) {
                return this.userInfoState.roles.includes('INTERNAL_USER');
            } return false;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        },
        publishingString: function () {
            if (this.publishingMethod == 1) {
                return this.issue + '/' + this.year;
            } else if (this.publishingMethod == 4) {
                return this.site;
            }
            return null;
        }
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        copyQuery() {
            var data = {
                act: this.form.actId,
                tk: this.form.titleQuery,
                bk: this.form.bodyQuery,
                chalAct: this.form.chalActId,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                essRule: this.form.essRule,
                articles: this.form.articles,
                relLaw: this.form.relLaw,
                lega: this.form.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubSubjectId : null,
                up: this.form.upisnik,
                limit: this.form.resultLimit,
                pspid: this.form.subItemSelection,
                pm: this.publishingMethod,
                ptf: this.procedureTypeFilterId,
                pt: this.form.procedureTypeId,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                bt: this.bilten,
                d: this.form.court,
                c: this.courtType,
                ct: 1,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                opid: (this.contentType == 1) ? this.form.subItemSelection : -1,
                spid: (this.contentType == 0) ? this.form.subItemSelection : -1,
            }

            var el = document.createElement('textarea');
            el.value = JSON.stringify({
                path: 'api/supa/ccSearch',
                payload: data
            });

            el.style.dislay = 'none';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            alert('Upit je kopiran u clipboard');
        },
        onSubmit(evt) {
            evt.preventDefault();


            // // Local DATA
            // let responseLocal = {"limit":50,"resultSize":2981,"result":[{"htmlUuid":"d40d8183-4693-8ac2-88a4-6de767b88205","courtName":"Уставни суд","subjectId":"IУз 62/2018","name":"Одбацивање иницијатице за покретање поступка за оцену уставности и сагласности са потврђеним међународним уговором Законика о кривичном поступку, уз издвојено мишљење судије - поступање јавног тужиоца, оштећеног и непосредно вишег јавног тужиоца у случају одбацивања кривичне пријаве, обуставе истраге или одустанка од кривичног гоњења до потврђивања оптужнице за кривично дело које се гони по службеној дужности","issuer":"Службени гласник РС","issuePage":"037/2019-056","date":"18.04.2019","year":null},{"htmlUuid":"7023e042-2dcf-ec3e-d2ff-52c0f5cc21b9","courtName":"Уставни суд","subjectId":"IУз 185/2018","name":"Одбацивање предлога за оцену уставности Закона о заштити конкуренције, уз издвојено мишљење судије – процесна мера заштите података или одређених података и слободан приступ информацијама од јавног значаја","issuer":"Службени гласник РС","issuePage":"045/2019-059","date":"25.04.2019","year":null},{"htmlUuid":"c9e6d640-6bd5-c831-cbb2-050c60be225a","courtName":"Уставни суд","subjectId":"Уж 13365/2018","name":"Одбијање као неосноване уставне жалбе због непостојања повреде права на слободу кретања из члана 39. Устава у погледу одређивања мере забране напуштања боравишта уз привремено одузимање путне исправе, уз издвојено мишљење судије","issuer":"Службени гласник РС","issuePage":"032/2019-037","date":"04.04.2019","year":null},{"htmlUuid":"ed391831-932b-9030-c168-db6b7c230d50","courtName":"Уставни суд","subjectId":"Уж 1971/2018","name":"Одбацивање уставне жалбе као очигледно неосноване, уз издвојено мишљење судије - непостојање повреде гаранције права на правично суђење утврђене чланом 32. став 1. Устава, нити права на рехабилитацију из члана 35. Устава","issuer":"Службени гласник РС","issuePage":"034/2019-181","date":"04.04.2019","year":null},{"htmlUuid":"ba0b7414-1a4b-a973-211e-acc47d7ebf7e","courtName":"Уставни суд","subjectId":"IУо 132/2018","name":"Одбијање предлога за утврђивање неуставности и незаконитости Колективног уговора за Јавно предузеће \"Пошта Србије\" - заштита представника синдиката који немају својство репрезентативности","issuer":"Службени гласник РС","issuePage":"023/2019-039","date":"21.02.2019","year":null},{"htmlUuid":"8a3aa9aa-b6dc-3566-a17a-7cb1fe908699","courtName":"Уставни суд","subjectId":"IУо 134/2018","name":"Оцена уставности и законитости Ближих критеријума за закључивање уговора о раду наставника након 65. године живота, које је донео Национални савет за високо образовање - измена законског услова за продужетак радног односа наставника у звању редовног професора","issuer":"Службени гласник РС","issuePage":"023/2019-041","date":"21.02.2019","year":null},{"htmlUuid":"9885a91a-7f3f-f71b-056b-99fe31dcccab","courtName":"Уставни суд","subjectId":"IУо 36/2017","name":"Оцена законитости Одлуке о условима и начину снабдевања топлотном енергијом, коју је донела Скупштина града Шапца и Тарифног система за обрачун топлотне енергије за тарифне купце, који је донело Градско веће града Шапца - непостојање законског овлашћења скупштина општине да извршном органу општине пренесе надлежност за доношење општих аката и прекорачење надлежности извршног органа јединице локалне самоуправе","issuer":"Службени гласник РС","issuePage":"017/2019-073","date":"17.01.2019","year":null},{"htmlUuid":"cb8499e6-e839-da7c-2966-2ffc98abe971","courtName":"Уставни суд","subjectId":"IУо 191/2018","name":"Оцена уставности Правилника о изменама и допунама Правилника о систематизацији радних места Јавног предузећа за газдовање шумама \"Србијашуме\" - непостојање оцене нарочито оправданих разлога за ступање на снагу општег акта даном објављивања у поступку његовог доношења","issuer":"Службени гласник РС","issuePage":"009/2019-077","date":"24.12.2018","year":null},{"htmlUuid":"d03f0d46-9b93-c34b-25a2-00861745f700","courtName":"Уставни суд","subjectId":"Уж 1438/2018 (8863/2014)","name":"Одбијање као неосноване уставне жалбе због непостојања повреде права на слободу кретања из члана 39. Устава у погледу одређивања мере забране напуштања боравишта уз привремено одузимање путне исправе, уз издвојено мишљење судије","issuer":"Службени гласник РС","issuePage":"007/2019-155","date":"06.12.2018","year":null},{"htmlUuid":"b0956d2e-afe7-8669-263a-13c538e62f57","courtName":"Уставни суд","subjectId":"Уж 1982/2016","name":"Одбацивање уставне жалбе против решења донетог у поступку рехабилитације као очигледно неосноване, уз издвојено мишљење судије","issuer":"Службени гласник РС","issuePage":"003/2019-124","date":"22.11.2018","year":null},{"htmlUuid":"c244f9ac-fcea-1b3e-234d-be3dcd718787","courtName":"Уставни суд","subjectId":"Уж 7451/2016","name":"Повреда права на правично суђење из члана 32. став 1. Устава у поступку по приговору за заштиту права на суђење у разумном року","issuer":"Службени гласник РС","issuePage":"098/2018-042","date":"25.10.2018","year":null},{"htmlUuid":"741a37ef-497c-08e1-9626-3cf786d7ac1d","courtName":"Уставни суд","subjectId":"IУо 163/2018","name":"Оцена уставности и законитости Одлуке о коефицијентима ЈКП Градско саобраћајно предузеће „Београд“ – утврђивање основне зараде за обављање синдикалне функције општим актом послодавца","issuer":"Службени гласник РС","issuePage":"092/2018-047","date":"25.10.2018","year":null},{"htmlUuid":"2fb1df38-8617-4d6c-8055-7877245e84f4","courtName":"Уставни суд","subjectId":"IУо 21/2018","name":"Оцена уставности Правилника о стручном усавршавању здравствених радника, здравствених сарадника и осталих запослених, Опште болнице Шабац - обавеза запосленог да врати све износе примљене на име зараде, накнаде зараде и других примања за време трајања специјализације, ако по положеној специјализацији не остане у болници дупло дуже од трајања специјализације","issuer":"Службени гласник РС","issuePage":"088/2018-085","date":"18.10.2018","year":null},{"htmlUuid":"45f58e97-4164-47ad-a3e7-864caee530f3","courtName":"Уставни суд","subjectId":"IУо 100/2018","name":"Оцена законитости Одлуке о локалним комуналним таксама, коју је донела Скупштина општине Сурдулица- овлашћење скупштине јединице локалне самоуправе да својим актом уведе локалну комуналну таксу за постављање линијских инфраструктурних објеката испод или изнад јавне површине","issuer":"Службени гласник РС","issuePage":"086/2018-080","date":"27.09.2018","year":null},{"htmlUuid":"3ed3e003-a7ac-02c0-7f5a-af21687ae48d","courtName":"Уставни суд","subjectId":"IУо 173/2017","name":"Оцена уставности и законитости Правилника о критеријумима и поступку доделе средстава црквама и верским заједницама, који је донео председник општине Бечеј - доношење општег акта од стране ненадлежног органа","issuer":"Службени гласник РС","issuePage":"068/2018-032","date":"05.07.2018","year":null},{"htmlUuid":"a3c1e880-22ea-0759-1de3-8e3697edd258","courtName":"Уставни суд","subjectId":"IУо 277/2015","name":"Оцена законитости Одлуке о стављању ван снаге дела Плана генералне регулације Брзеће и Одлуке о стављању ван снаге дела Плана генералне регулације Бруса - поступак измена и допуна планског документа","issuer":"Службени гласник РС","issuePage":"065/2018-198","date":"05.07.2018","year":null},{"htmlUuid":"ec36c7a7-91e0-79f4-f9a6-14ede1c37564","courtName":"Уставни суд","subjectId":"Уж 4899/2015","name":"Одбијање као неосноване уставне жалбе због непостојања повреде на правично суђење из члана 32. став 1. Устава у поступку вођеном по захтеву за исправку грешке уписа у матичној књизи рођених, са издвојеним мишљењем судије","issuer":"Службени гласник РС","issuePage":"043/2018-160","date":"28.05.2018","year":null},{"htmlUuid":"4fcb5de3-bbe0-5199-fc7f-90b09794de95","courtName":"Уставни суд","subjectId":"Уж 738/2014","name":"Повреда права на ограничено трајање притвора из члана 31. став 2. Устава, уз издвојено мишљење судије","issuer":"Службени гласник РС","issuePage":"034/2018-096","date":"29.03.2018","year":null},{"htmlUuid":"6c33ad49-4721-b537-d520-859f00d09a0b","courtName":"Уставни суд","subjectId":"IУо 197/2017","name":"Оцена законитости Одлуке о условима и начину држања домаћих животиња - законска забрана спровођења огледа на животињама","issuer":"Службени гласник РС","issuePage":"086/2019-167","date":"24.10.2019","year":null},{"htmlUuid":"77e0576b-271f-1e63-c781-08d29ff77805","courtName":"Уставни суд","subjectId":"Уж 1044/2017","name":"Повреда права на правно средство из члана 36. став 2. Устава у поступку по захтеву за преиспитивање судске одлуке","issuer":"Службени гласник РС","issuePage":"078/2019-043","date":"26.09.2019","year":null},{"htmlUuid":"f6ac29bf-c92d-26a6-a521-6764b08cf119","courtName":"Уставни суд","subjectId":"Уж 5371/2017","name":"Одбијање као неосноване уставне жалбе због непостојања повреде права на правично суђење из члана 32. став 1. Устава у поступку за заштиту права конкуренције","issuer":"Службени гласник РС","issuePage":"068/2019-059","date":"04.07.2019","year":null},{"htmlUuid":"3b98e204-e4ec-55ce-760d-01efd5ea4e42","courtName":"Уставни суд","subjectId":"IУз 130/2017","name":"Оцена уставности Закона о пензијском и инвалидском осигурању - неуставност пооштравања услова за остваривање права на породичну пензију само за ситуацију када се брачна заједница заснује после 65. године живота осигураника, односно корисника пензије","issuer":"Службени гласник РС","issuePage":"046/2019-159","date":"25.04.2019","year":null},{"htmlUuid":"3dca4272-e3bd-f17d-b6a7-91738c9143a5","courtName":"Уставни суд","subjectId":"Уж 5149/2017","name":"Повреда права на правично суђење из члана 32. став 1. Устава у поступку по ревизији у штампарском спору - основе за изјављивање ревизије","issuer":"Службени гласник РС","issuePage":"045/2019-057","date":"25.04.2019","year":null},{"htmlUuid":"c083c0db-d60f-5f99-ff03-59eb9f1d363c","courtName":"Уставни суд","subjectId":"IУо 189/2017","name":"Оцена уставности Колективног уговора код послодавца \"Сава Ковачевић\" АД Врбас од 25. новембра 2015. године - неуставност ступања на снагу општег правног акта даном његовог потписивања","issuer":"Службени гласник РС","issuePage":"025/2019-112","date":"21.02.2019","year":null},{"htmlUuid":"032edd03-7799-7913-3306-a9ecc41721e7","courtName":"Уставни суд","subjectId":"IУо 32/2017","name":"Оцена законитости Одлуке о локалним комуналним таксама (Таксене тарифе), коју је донела Скупштине града Новог Пазара - увођење локалне комуналне таксе проширивањем таксеног основа одлуком јединице локалне самоуправе","issuer":"Службени гласник РС","issuePage":"092/2018-046","date":"25.10.2018","year":null},{"htmlUuid":"e1c3d9ed-ca83-4af5-66f0-c86d3ba0a72c","courtName":"Уставни суд","subjectId":"IУо 138/2017","name":"Оцена законитости Правилника о организацији и систематизацији радних места у органима и службама општине Бечеј - обавеза прибављања мишљења репрезентативног синдиката у поступку припреме правилника","issuer":"Службени гласник РС","issuePage":"004/2019-048","date":"18.10.2018","year":null},{"htmlUuid":"12c35b11-c674-a223-c0ba-2e4c946a5e79","courtName":"Уставни суд","subjectId":"IУо 90/2017","name":"Оцена законитости Таксене тарифе, која је саставни део Одлуке о локалним комуналним таксама Скупштине општине Куршумлија - надлежност скупштине јединице локалне самоуправе да својим актом уведе локалну комуналну таксу за постављање линијских инфраструктурних објеката испод или изнад јавне површине","issuer":"Службени гласник РС","issuePage":"065/2018-195","date":"05.07.2018","year":null},{"htmlUuid":"852c347f-9aa1-a3f3-c40a-e2930db5b7cc","courtName":"Уставни суд","subjectId":"IУо 142/2017","name":"Оцена законитости Правилника и Допуне Правилника о унутрашњој систематизацији и организацији радних места у Спортском савезу града Врања - обавеза прописивања врсте и степена стручне спреме и законско ограничење у погледу алтернативног одређивања више степена стручне спреме као услова за обављање одређених послова","issuer":"Службени гласник РС","issuePage":"094/2018-053","date":"05.07.2018","year":null},{"htmlUuid":"16543fc5-9f2c-eb0e-4bb7-946bd12d807a","courtName":"Уставни суд","subjectId":"IУо 61/2017","name":"Оцена уставности Правилника о стручном усавршавању, образовању и специјализацији запослених, Опште болнице Пожаревац - обавеза запосленог да врати све износе примљене на име зараде, накнаде зараде и других примања за време трајања специјализације, ако по положеној специјализацији не остане у болници дупло дуже од трајања специјализације","issuer":"Службени гласник РС","issuePage":"054/2018-093","date":"24.05.2018","year":null},{"htmlUuid":"d74bfba4-df7e-fea7-6dd9-6326bb46a355","courtName":"Уставни суд","subjectId":"IУо 86/2017","name":"Оцена законитости Таксене тарифе која је саставни део Одлуке о локалним комуналним таксама, коју је донела Скупштина општине Лебане - надлежност скупштине јединице локалне самоуправе да својим актом уведе локалну комуналну таксу за постављање линијских инфраструктурних објеката испод или изнад јавне површине","issuer":"Службени гласник РС","issuePage":"054/2018-095","date":"24.05.2018","year":null},{"htmlUuid":"bb3a8dcd-d36d-b1a0-cd2c-1454c934e2c8","courtName":"Уставни суд","subjectId":"IУо 87/2017","name":"Оцена законитости Одлуке о јавним паркиралиштима, коју је донела Скупштина града Лознице - назаконитост прописивања више (различитих) новчаних обавеза кориснику услуге паркирања, по основу истог начина коришћења паркиралишта","issuer":"Службени гласник РС","issuePage":"056/2018-138","date":"24.05.2018","year":null},{"htmlUuid":"8d9e810e-e90a-4119-8cdc-a3a491f7c50f","courtName":"Уставни суд","subjectId":"IУo 68/2017","name":"Оцена уставности Измена и допуна Плана расподеле накнада остварених искоришћавањем фонограма од 27. марта 2016. године - неуставност ступања на снагу општег акта даном доношења","issuer":"Службени гласник РС","issuePage":"043/2018-158","date":"26.04.2018","year":null},{"htmlUuid":"704f9d1b-02ec-619d-8d55-640ff2916334","courtName":"Уставни суд","subjectId":"IУо 122/2017","name":"Оцена законитости Одлуке о месним заједницама и другим облицима месне самоуправе на територији градске општине Младеновац - питања која се аутономно уређују актима месне заједнице","issuer":"Службени гласник РС","issuePage":"019/2018-060","date":"25.01.2018","year":null},{"htmlUuid":"473dbedb-4693-1dbe-781a-8ba1eb8f30b8","courtName":"Уставни суд","subjectId":"IУо 279/2016","name":"Оцена уставности и законитости Одлуке о утврђивању својства осигураника и обавези плаћања доприноса за пензијско и инвалидско осигурање - непостојање овлашћења Републичког фонда за пензијско и инвалидско осигурање да својим актом уређује питање утврђивања доприноса ван случајева када утврђује својство осигураника","issuer":"Билтен Уставног суда","issuePage":"01/2017-273","date":"21.12.2017","year":null},{"htmlUuid":"9b3c49a3-5dab-935a-fca5-a4b388d8922e","courtName":"Уставни суд","subjectId":"IУо 70/2017","name":"Оцена уставности и законитости Одлуке о накнадама и другим примањима запослених у градским управама и изабраних, односно постављених лица, коју је донела Скупштина града Новог Пазара - немогућност прописивања актом јединице локалне самоуправе увећања плате по основу додатка за који је Законом предиђено да је садржан у коефицијенту","issuer":"Билтен Уставног суда","issuePage":"01/2017-179","date":"22.06.2017","year":null},{"htmlUuid":"4ca3b0dd-04ed-d8c9-5403-b61d98f66392","courtName":"Уставни суд","subjectId":"IУо 9/2014","name":"Оцена уставности и законитости Правилника о типу, величини, условима и поступку за постављање објеката и средстава за оглашавање на територији града Београда - непостојање овлашћења градоначелника за доношење општег правног акта","issuer":"Билтен Уставног суда","issuePage":"01/2017-189","date":"08.06.2017","year":null},{"htmlUuid":"a971a579-088d-c919-8ba3-c2bd0253ab4b","courtName":"Уставни суд","subjectId":"IIIУ 9/2017","name":"Решавање негативног сукоба надлежности између прекршајног суда и другог државног органа за вођење прекршајног поступка","issuer":"Сајт","issuePage":"www.ustavni.sud.rs","date":"06.04.2017","year":null},{"htmlUuid":"f2b01f51-cf1a-f400-3dda-ba69cefb218d","courtName":"Уставни суд","subjectId":"Уж 2900/2016","name":"Повреда права на хитно одлучивање о законитости лишења слобода из члана 27. став 3. Устава у поступку по жалби на решење о задржавању осумњиченог","issuer":"Службени гласник РС","issuePage":"055/2019-078","date":"04.07.2019","year":null},{"htmlUuid":"b5b897ff-0f8a-8218-da96-f0cd9f647e48","courtName":"Уставни суд","subjectId":"IУо 98/2016","name":"Оцена уставности и законитости Правилника о унутрашњој организацији и систематизацији радних места Регионалног центра за професионални развој запослених у образовању Смедеревo - утврђивање услова у погледу стручне спреме за обављање послова одређеног радног места актом о систематизацији","issuer":"Службени гласник РС","issuePage":"082/2019-112","date":"20.06.2019","year":null},{"htmlUuid":"a95e73da-4a78-940c-dc85-a5e175b04702","courtName":"Уставни суд","subjectId":"IУз 249/2016","name":"Одбијање предлога за оцену уставности и сагласности са потврђеним међународним уговором Закона о привредним коморaма - законом прописано обавезно чланство привредних субјеката у привредној комори","issuer":"Службени гласник РС","issuePage":"045/2019-052","date":"18.04.2019","year":null},{"htmlUuid":"7471c1dc-d0b2-a663-6dd0-aa7522debd38","courtName":"Уставни суд","subjectId":"Уж 3456/2016 (1)","name":"Испуњеност услова за преипитивање и стављање ван снаге одлуке Уставног суда","issuer":"Службени гласник РС","issuePage":"037/2019-055","date":"21.03.2019","year":null},{"htmlUuid":"781a8d0a-6474-121a-2aa6-8139210a0e4d","courtName":"Уставни суд","subjectId":"Уж 273/2016","name":"Повреда права на правно средство из члана 36. став 2. Устава ускраћивањем права да се пред судом мериторно одлучи о захтеву за преиспитивање судске одлуке - акт о престанку професионалне војне службе","issuer":"Службени гласник РС","issuePage":"025/2015-114","date":"21.02.2019","year":null},{"htmlUuid":"72927de4-6182-43df-98db-4ed80abda35d","courtName":"Уставни суд","subjectId":"Уж 6666/2016","name":"Одбијање као неосноване уставне жалбе због непостојања повреде права на рад из члана 60. Устава, уз издвојено мишљење судија - испуњеност услова за престанак цивилилне службе у Војсци","issuer":"Службени гласник РС","issuePage":"004/2019-050","date":"06.12.2018","year":null},{"htmlUuid":"1f51c0f9-12a0-2e30-81e5-594f955e507c","courtName":"Уставни суд","subjectId":"Уж 6463/2016","name":"Одбијање као неосноване уставне жалбе због непостојања повреде права на правично суђење из члана 32. став 1. Устава, уз издвојено мишљење судије и сагласно издвојено мишљење судије - продужено кривично дело и апсолутна застарелост кривичног гоњења","issuer":"Службени гласник РС","issuePage":"006/2019-146","date":"22.11.2018","year":null},{"htmlUuid":"ecd1b8c4-e141-0941-16e5-b56701d35821","courtName":"Уставни суд","subjectId":"IУо 47/2016","name":"Оцена законитости Одлуке о накнади за заштиту и унапређивање животне средине града Зајечара - неспровођење законом прописаног поступка доношења одлуке, неспровођење јавне расправе","issuer":"Службени гласник РС","issuePage":"106/2018-079","date":"22.11.2018","year":null},{"htmlUuid":"573fb28c-a083-98a2-65e1-a0043c62cbaa","courtName":"Уставни суд","subjectId":"IУо 75/2016","name":"Оцена уставности и законитости Правилника о условима и начину упућивања запослених у ЈП ЕПС Београд–огранак ХЕ „Ђердап” Кладово - ненадлежност синдикалне организације за доношење општих аката којима се уређује права запослених по основу рада","issuer":null,"issuePage":null,"date":"08.11.2018","year":null},{"htmlUuid":"8278a67a-d3c9-7b0c-3af8-1f723dcb3af7","courtName":"Уставни суд","subjectId":"IУo 67/2016","name":"Оцена законитости Правилника о превозу запослених у ПД \"ПРО ТЕНТ\" - непостојање овлашћења послодавца да својим актом ограничи законом предвиђено право запосленог на накнаду трошкова превоза","issuer":"Службени гласник РС","issuePage":"096/2018-213","date":"08.11.2018","year":null},{"htmlUuid":"bdc2ce03-b3b3-9f69-b1cd-7d677d4872d4","courtName":"Уставни суд","subjectId":"Уж 1202/2016","name":"Повреда права на имовину из члана 58. став 1. Устава - прекршај из области девизног пословања, несразмерност у санкционисању нарушавања јавног интереса са Уставом зајемченим правом на мирно уживање имовине, уз издвојено сагласно мишљење судије","issuer":"Службени гласник РС","issuePage":"099/2018-103","date":"08.11.2018","year":null},{"htmlUuid":"b831962b-0be0-5871-3fc3-e55ebcc6719d","courtName":"Уставни суд","subjectId":"Уж 3366/2016","name":"Повреда права на слободу и безбедност из члана 27. Устава у поступку лишења слободе","issuer":"Службени гласник РС","issuePage":"099/2018-110","date":"08.11.2018","year":null},{"htmlUuid":"75bc5fc8-d612-09e1-ac9a-8eb539ea0c1b","courtName":"Уставни суд","subjectId":"IУо 257/2016","name":"Оцена уставности и законитости Правилника о критеријумима, мерилима и поступку за оцењивање рада судијских помоћника","issuer":"Службени гласник РС","issuePage":"103/2018-076","date":"08.11.2018","year":null}]};
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;
            // for (var i = 0; i < this.result.length; i++) {
            //     this.result[i].timestamp = moment(this.result[i].date, 'DD.MM.YYYY').valueOf();
            // }

            const vm = this;
            var data = {
                act: this.form.actId,
                tk: this.form.titleQuery,
                bk: this.form.bodyQuery,
                chalAct: this.form.chalActId,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                essRule: this.form.essRule,
                articles: this.form.articles,
                relLaw: this.form.relLaw,
                lega: this.form.legalAreaId,
                legs: this.legalSubjectId,
                legss: (this.legalSubjectId > 0) ? this.legalSubSubjectId : null,
                up: this.form.upisnik,
                limit: this.form.resultLimit,
                pspid: this.form.subItemSelection,
                pm: this.publishingMethod,
                ptf: this.procedureTypeFilterId,
                pt: this.form.procedureTypeId,
                bn: (this.publishingMethod == 1) ? (this.issue + '/' + this.year) : null,
                bt: this.bilten,
                d: this.form.court,
                c: this.courtType,
                ct: 1,
                desc: (this.contentType == 1),
                other: (this.contentType == 3),
                resp: (this.contentType == 2),
                sent: (this.contentType == 0),
                opid: (this.contentType == 1) ? this.form.subItemSelection : -1,
                spid: (this.contentType == 0) ? this.form.subItemSelection : -1,
            };
            //added velja and aleksandar
            if (this.publishingMethod == -1) {
                data.bt = this.bilten;
            }
            // publisheMethod Начин објављивања
            if (this.publishingMethod == 3) {
                data.bt = this.book;

            }
            if (this.publishingMethod == 4) {
                data.bn = this.site;

            }
            axios.post(this.baseDIApiUrl + 'sp/advancedSearchCC', data)
                .then(response => {
                    console.log("response from main supa CC search", response);
                    var data = response.data.result;

                    for (var i = 0; i < data.length; i++) {
                        data[i].timestamp = moment(data[i].date, 'DD.MM.YYYY').valueOf();
                    }

                    this.result = data;
                    this.resultSize = response.data.resultSize;
                    this.limit = response.data.limit;
                }).catch(function (error) {
                    console.log(error);
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });
        },
        onReset() {
            this.courtType = -1;
            this.contentType = -1;
            this.contentSubtype = -1;
            this.procedureTypeFilterId = -1;
            this.legalSubjectId = -1;
            this.legalSubSubjectId = -1;
            this.publishingMethod = -1;

            this.dateFrom = null;
            this.dateTo = null;
            this.emitedDateFromVal = null;
            this.emitedDateToVal = null;

            this.form = {

                legalAreaId: -1,
                procedureTypeId: -1,
                chalActId: null,
                essRule: null,
                articles: null,
                itemSelection: -1,
                subItemSelection: -1,
                upisnik: -1,
                actId: null,
                relLaw: null,
                court: -1,
                regulation: null,
                titleQuery: null,
                bodyQuery: null,
                resultLimit: 50,
            };
            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        },
        fetchFilterData() {
            axios
                .get(this.baseSPApiUrl + 'prins/ccSearch/filter')
                .then(response => {
                    this.filterData = response.data;
                    this.courtTypes = response.data.courtTypes;
                    this.upisnikList = response.data.up;
                    this.procedureTypes = response.data.procTypesActive;
                    this.legalAreas = response.data.legalAreas;
                    this.legalSubjects = response.data.legalSubjects;
                    // this.docTypes = response.data.docTypes;
                }).catch(function (error) {
                    console.log(error);
                });
        },
        fetchFilterData2() {
            axios
                .get(this.baseSPApiUrl + 'prins/sadrzi/1')
                .then(response => {
                    this.itemSelectionsList = response.data;
                    // this.docTypes = response.data.docTypes;
                }).catch(function (error) {
                    console.log(error);
                });
        },
    },
    watch: {
        courtType: function () {
            this.court = -1;
            axios.get(this.baseSPApiUrl + 'prins/departments/1/' + this.courtType)
                .then(response => {
                    this.courts = response.data;
                });
        },
        contentType: function () {

            if (this.contentType == -1) {
                this.form.subItemSelection = -1;
                this.subItemSelectionsList = [];
                return;
            }

            if(this.contentType === 3) this.subItemSelectionsList = [];

            let selectedParams = null;

            switch (this.contentType) {
                case 1:
                    selectedParams = "contentSubtype?obrazlozenje=true&sentenca=false&pravniStav=false";
                    break;
                case 0:
                    selectedParams = "contentSubtype?obrazlozenje=false&sentenca=true&pravniStav=false";
                    break;
                case 2:
                    selectedParams = "contentSubtype?obrazlozenje=false&sentenca=false&pravniStav=true";
                    break;
                default:
                    selectedParams = null;
            }

            if (selectedParams) {
                // http://pravno-informacioni-sistem.rs/SlGlasnikPortal/api/supa/0/contentSubtype?obrazlozenje=true&sentenca=false&pravniStav=false
                axios.get(this.baseSPApiUrl + 'prins/0/' + selectedParams)
                    .then(response => {
                        this.subItemSelectionsList = response.data;
                        this.form.subItemSelection = -1;
                    })
            }
        },
        procedureTypeFilterId: function () {
            if (this.procedureTypeFilterId == 0) {
                this.procedureTypes = this.filterData.procTypesInactive;
            } else {
                this.procedureTypes = this.filterData.procTypesActive;
            }
            this.form.procedureTypeId = -1;
        },
        legalSubjectId: function () {
            axios.get(this.baseSPApiUrl + 'prins/legalSubSubject/1/' + this.legalSubjectId)
                .then(response => {
                    this.legalSubSubjects = response.data;
                    this.legalSubSubjectId = -1;
                })
        },
        publishingMethod: function () {
            this.years = [];
            this.issues = [];
            this.sites = [];
            this.biltens = [];
            this.books = [];

            this.year = '*';
            this.issue = '*';
            this.bilten = -1;
            this.book = -1;
            this.site = '*';

            if (this.publishingMethod == 1) {
                axios.get(this.baseSPApiUrl + 'prins/gazette/years/1')
                    .then(response => {
                        console.log("response years", response);
                        this.years = response.data;
                    })
            } else if (this.publishingMethod == 2) {
                axios.get(this.baseSPApiUrl + 'prins/bilteni/1')
                    .then(response => {
                        console.log("response biltens", response);
                        this.biltens = response.data;
                    })
            } else if (this.publishingMethod == 3) {
                axios.get(this.baseSPApiUrl + 'prins/books/1')
                    .then(response => {
                        console.log("response books", response);
                        this.books = response.data;
                    })
            } else if (this.publishingMethod == 4) {
                axios.get(this.baseSPApiUrl + 'prins/websites/1')
                    .then(response => {
                        console.log("webiste", response);
                        this.sites = response.data;
                    })
            }
        },
        year: function () {
            this.issue = '*';
            if (this.year !== '*') {
                axios.get(this.baseSPApiUrl + 'prins/gazette/numbers/1/' + this.year)
                    .then(response => {
                        this.issues = response.data;
                    })
            } else {
                this.issues = [];
            }
        }
    },
    mounted() {
        console.log("mounted")
        this.fetchFilterData();
        this.fetchFilterData2();
    },
    beforeCreate: function () {
        document.body.className = 'color_supa';
    }
}
</script>

<style >
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 15%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 35%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 25%;
}

.table-bootstrap-vue thead tr th:nth-child(6) {
    width: 10%;
}
</style>
